import { config } from '@abyss/ui/tools/config';
import { useQuery } from '../../tools/useQuery';

const url = `${config(
  'PAAN_ICUE_STARGATE_API_URL'
)}/reference/v1/effectivecacheList/zipRadiusType`;

const parseResult = result => {
  const initialState = [];

  if (result) {
    return result.sort((a, b) =>
      a.referenceDesc.localeCompare(b.referenceDesc)
    );
  }

  return initialState;
};

export const usePaanZipRadiusType = options => {
  const queryOptions = options;
  queryOptions.method = 'GET';

  const [queryResult, queryAction] = useQuery(url, {
    ...queryOptions,
    onCompleted: result => {
      if (options.onCompleted) {
        options.onCompleted(parseResult(result.body));
      }
    },
  });

  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
